import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // console.log("this.auth.getToken()",this.auth.userValue);
    // console.log("this.auth.getTocurrentUserValueken()",this.auth.currentUserValue())

     // add auth header with jwt if user is logged in and request is to the api url
     const user = this.auth.userValue;
     const isLoggedIn = user && user.authToken;
     const isApiUrl = request.url.startsWith(environment.apiUrl);
     if (isLoggedIn && isApiUrl) {
         request = request.clone({
             setHeaders: { Authorization: `Bearer ${user.authToken}` }
         });
     } else{       
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer`
      }
    });
     }
    return next.handle(request);
  }
}